import type { Feature, FeatureCollection, Point } from 'geojson';

import type { FeatureType } from '@/types/FeatureType';

export interface PickupParkingFacilityProperties {
  id: string;
  name: string;
  featureType: typeof FeatureType.PICKUP_PARKING_FACILITY;

  administrativedistrict: string | null;
  citationphoto: string | null;
  citationtext: string | null;
  city: string | null;
  citydistrict: string | null;
  communitycode: number | null;
  destination1: string | null;
  destination2: string | null;
  destination3: string | null;
  federalstate: string | null;
  housenumber: string | null;
  infotextlong: string | null;
  postcode: number | null;
  region: string | null;
  remark: string | null;
  stationplanlink: string | null;
  status: string | null;
  street: string | null;
  timetablelink: { text: string; source: string } | null;
  usageconstraintsphoto: string | null;
  usageconstraintstext: string | null;
  validfromtimestamp: string | null;
  validtotimestamp: string | null;
  visibility: number | null;
  objectid: number;
  code: string | null;
  creator: string | null;
  enddate: string | null;
  externalid: string | null;
  externalorgcode: string | null;
  featurename: string;
  group_id: number | null;
  importance: string | null;
  linegeometry: number | null;
  pointgeometry: number | null;
  polygongeometry: number | null;
  x: number | null;
  y: number | null;
  startdate: string | null;
  timestamp: string | null;
  validfrom: string | null;
  validto: string | null;
  sde_id: number | null;
  modify_timestamp: string | null;
  cleanness: number | null;
  regularparkingspacenumber: number | null;
  infotextshort: string | null;
  markedparkingspaces: string | null;
  sealedparking: string | null;
  sealtype: string | null;
  illuminated: string | null;
  bustrainconnection: number | null;
  frequencybustrainconnection: string | null;
  ususalutilisation: number | null;
  utilizationclass: string | null;
  equipmentwitingarea: string | null;
  measureproposal2: string | null;
  measureproposal3: string | null;

  photo_1_url: string | null;
  photo_1_text: string | null;
  photo_1_citation: string | null;
  photo_1_usage_constraints: string | null;

  photo_2_url: string | null;
  photo_2_text: string | null;
  photo_2_citation: string | null;
  photo_2_usage_constraints: string | null;

  photo_3_url: string | null;
  photo_3_text: string | null;
  photo_3_citation: string | null;
  photo_3_usage_constraints: string | null;

  photo_4_url: string | null;
  photo_4_text: string | null;
  photo_4_citation: string | null;
  photo_4_usage_constraints: string | null;

  photo_5_url: string | null;
  photo_5_text: string | null;
  photo_5_citation: string | null;
  photo_5_usage_constraints: string | null;
}

export const PICKUP_PARKING_FACILITY_PHOTO_FIELDS = [
  {
    url: 'photo_1_url',
    text: 'photo_1_text',
    citation: 'photo_1_citation',
    usageConstraints: 'photo_1_usage_constraints',
  },
  {
    url: 'photo_2_url',
    text: 'photo_2_text',
    citation: 'photo_2_citation',
    usageConstraints: 'photo_2_usage_constraints',
  },
  {
    url: 'photo_3_url',
    text: 'photo_3_text',
    citation: 'photo_3_citation',
    usageConstraints: 'photo_3_usage_constraints',
  },
  {
    url: 'photo_4_url',
    text: 'photo_4_text',
    citation: 'photo_4_citation',
    usageConstraints: 'photo_4_usage_constraints',
  },
  {
    url: 'photo_5_url',
    text: 'photo_5_text',
    citation: 'photo_5_citation',
    usageConstraints: 'photo_5_usage_constraints',
  },
] as const;

export type PickupParkingFacilityFeature = Feature<Point, PickupParkingFacilityProperties>;

export type PickupParkingFacilityFeatureCollection = FeatureCollection<Point, PickupParkingFacilityProperties>;
